import { useIsAdmin } from '../../../utils/useIsAdmin'
import {
  // useGetPlanMenuControlDimensionOnlyReadQuery, //используем один endpoint для всех ролей
  useGetPlanMenuControlDimensionQuery,
} from '../../../core/api/PlanMenuControlApi'
import { IPlanMenuControlOrdersRequest } from '../../../core/api/dto/PlanMenuControlDto'

export const useGetDimensionListByRole = (
  pageParams?: IPlanMenuControlOrdersRequest | null,
  currentDishId?: string | null,
  dishId?: string,
) => {
  const isAdmin = useIsAdmin()

  const adminResult = useGetPlanMenuControlDimensionQuery(
    { id: Number(currentDishId ? currentDishId : dishId), ...pageParams },
    {
      // было: skip: (!currentDishId && !dishId) || isAdmin === false || isAdmin === null,
      skip: !currentDishId && !dishId,
      selectFromResult: (r) => ({
        ...r,
        data: r.isError ? undefined : (r.currentData as any[] | undefined),
      }),
    },
  )

  // было разделение по роли — OnlyRead для менеджера, admin для супервизора/администратора
  // const readOnlyResult = useGetPlanMenuControlDimensionOnlyReadQuery(
  //   {
  //     order_line: Number(currentDishId ? currentDishId : dishId),
  //     ...pageParams,
  //   },
  //   {
  //     skip: (!currentDishId && !dishId) || isAdmin || isAdmin === null,
  //     selectFromResult: (r) => ({
  //       ...r,
  //       data: r.isError ? undefined : (r.currentData as any[] | undefined),
  //     }),
  //   },
  // )
  // const res = isAdmin ? adminResult : readOnlyResult

  return {
    data: adminResult.data as any[] | undefined,
    isError: adminResult.isError ?? false,
    isLoading: adminResult.isLoading ?? false,
    isFetching: adminResult.isFetching ?? false,
  }
}
